// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/elt-detection-406-vs-121-5.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/elt-detection-406-vs-121-5/elt-detection-406-vs-121-5.js';

mount([g0]);
